// extracted by mini-css-extract-plugin
module.exports = {"pressItem":"AIPress_pressItem__aQ7mX"};